import React from 'react';

export default function(props) {
	const classes = ["ad_action_link", ...((props.className || "").split(" "))];
	return (
		<span
			role="button"
			tabIndex="0"
			onClick={props.on_click}
			onKeyPress={props.on_click}
			className={classes.join(" ")}
		>
			{props.children}
		</span>
	);
}




// WEBPACK FOOTER //
// ./src/c/ActionLink.js